import { GetConceptListAction } from './GetConceptListAction';
import { GetValueSetListAction } from './GetValueSetListAction';
import { GetSelctedConceptAction } from './GetSelctedConceptAction';
import { CreateCodeSystemVersionDraftAction } from './CreateCodeSystemVersionDraftAction';
import { CreateCodeSystemVersionDraftSuccessAction } from './CreateCodeSystemVersionDraftSuccessAction';
import { FinalizeCodeSystemVersionDraftAction } from './FinalizeCodeSystemVersionDraftAction';
import { FinalizeCodeSystemVersionDraftSuccessAction } from './FinalizeCodeSystemVersionDraftSuccessAction';
import { DeleteCodeSystemVersionDraftAction } from './DeleteCodeSystemVersionDraftAction';
import { DeleteCodeSystemVersionDraftSuccessAction } from './DeleteCodeSystemVersionDraftSuccessAction';
import { DuplicationFoundAction } from './DuplicationFoundAction';
import { UndoDeleteConceptVersionAction } from './UndoDeleteConceptVersionAction';
import { UndoDeleteConceptVersionSuccessAction } from './UndoDeleteConceptVersionSuccessAction';
import { ClearVocabularyCacheAction } from './ClearVocabularyCacheAction';
import { ClearVocabularyCacheSuccessAction } from './ClearVocabularyCacheSuccessAction';


export type Actions<TModel> = GetConceptListAction<TModel> |
                              GetValueSetListAction<TModel> |
                              GetSelctedConceptAction<TModel> |
                              CreateCodeSystemVersionDraftAction |
                              CreateCodeSystemVersionDraftSuccessAction |
                              FinalizeCodeSystemVersionDraftAction |
                              FinalizeCodeSystemVersionDraftSuccessAction |
                              DeleteCodeSystemVersionDraftAction |
                              DeleteCodeSystemVersionDraftSuccessAction |
                              DuplicationFoundAction |
                              UndoDeleteConceptVersionAction |
                              UndoDeleteConceptVersionSuccessAction |
                              ClearVocabularyCacheAction |
                              ClearVocabularyCacheSuccessAction;

export * from './GetConceptListAction';
export * from './GetValueSetListAction';
export * from './GetSelctedConceptAction';
export * from './CreateCodeSystemVersionDraftAction';
export * from './CreateCodeSystemVersionDraftSuccessAction';
export * from './FinalizeCodeSystemVersionDraftAction';
export * from './FinalizeCodeSystemVersionDraftSuccessAction';
export * from './DeleteCodeSystemVersionDraftAction';
export * from './DeleteCodeSystemVersionDraftSuccessAction';
export * from './DuplicationFoundAction';
export * from './UndoDeleteConceptVersionAction';
export * from './UndoDeleteConceptVersionSuccessAction';
export * from './ClearVocabularyCacheAction';
export * from './ClearVocabularyCacheSuccessAction';





// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/index.ts